import React, { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import LinearProgress from "@mui/material/LinearProgress";
import { ArgusMenu, getMenuConfig, permissionCheckerUtil } from "@mnemonic/argus-menu";
import { RawIntlProvider } from "@mnemonic/intl";
import Logger from "@mnemonic/logging";
import { RemoveSplash } from "@mnemonic/mui5";
import * as ArgusUtils from "@mnemonic/pure-utils/ArgusUtils";
import { Routes } from "@mnemonic/router";
import { ApplicationSession } from "./ApplicationWrappers/ApplicationSession";
import ThemeProvider from "./ApplicationWrappers/ThemeProvider";
import TopLevelErrorBoundary from "./Components/TopLevelErrorBoundary";
import { routeDefinitions } from "./Routes/routeDefinitions";
const Application = ({ session, intl }) => {
    const { domain, apiUrl } = ArgusUtils.getTargetMeta();
    const menuConfig = getMenuConfig(domain, session?.user, intl?.locale, Logger.getInstance());
    return (<TopLevelErrorBoundary>
      <ThemeProvider session={session} intl={intl}>
        <RawIntlProvider value={intl}>
          <ApplicationSession session={session} apiUrl={apiUrl}>
            <BrowserRouter basename={__PACKAGE__BASENAME__}>
              <ArgusMenu {...{
        ...permissionCheckerUtil(session, menuConfig),
        logger: Logger.getInstance(),
    }}>
                <Suspense fallback={<LinearProgress color="secondary"/>}>
                  <TopLevelErrorBoundary>
                    <RemoveSplash />
                    <Routes context={{ session }} routeDefinitions={routeDefinitions}/>
                  </TopLevelErrorBoundary>
                </Suspense>
              </ArgusMenu>
            </BrowserRouter>
          </ApplicationSession>
        </RawIntlProvider>
      </ThemeProvider>
    </TopLevelErrorBoundary>);
};
export default Application;
